import clsx from "clsx";
import { useTranslation } from "react-i18next";

import type { ChildDisplayStatus } from "../types";

import { Typo } from "../../Typo";

type StatusPillProps = {
  status: ChildDisplayStatus;
};

// Active is the normal state and renders no pill — only abnormal states get
// a tag, matching the source design (Pending KYC / Archived).
export const StatusPill = ({ status }: StatusPillProps) => {
  const { t } = useTranslation();

  if (status === "active") return null;

  const config =
    status === "pendingKyc"
      ? {
          label: t("subIBReport_statusProfileIncomplete", "Profile incomplete"),
          bgClassName: "bg-surface-accent-amber-subtler",
          textColor: "text-text-accent-amber-boldest" as const,
        }
      : {
          label:
            status === "inactive"
              ? t("subIBReport_statusInactive", "Inactive")
              : t("subIBReport_statusArchivedLabel", "Archived"),
          bgClassName: "bg-surface-tags-grey",
          textColor: "text-text-primary" as const,
        };

  return (
    <span
      className={clsx(
        "inline-flex h-5 shrink-0 items-center whitespace-nowrap rounded-full px-1",
        config.bgClassName,
      )}
    >
      <Typo
        element="span"
        type="label2XS"
        textColor={config.textColor}
        className="whitespace-nowrap px-0.5"
      >
        {config.label}
      </Typo>
    </span>
  );
};
